import React from 'react';

import { texts } from 'utils/languages/fr';

import DistributorEmailList from './DistributorEmailList';
import { ListContainer } from 'components';
import { Typography } from '@mui/material';

const Communication = () => (
    <ListContainer>
        <Typography variant="h5" gutterBottom>
            {texts.COMMUNICATIONS}
        </Typography>
        <DistributorEmailList emailsKey="distributorBillCCEmails" title={texts.COMPANY_EMAILS} />
        <DistributorEmailList emailsKey="reportingCCEmails" title={texts.REPORTING_EMAILS} />
        <DistributorEmailList
            emailsKey="capitalAccountCCEmails"
            title={texts.CAPITAL_ACCOUNTS_EMAILS}
        />
        <DistributorEmailList
            emailsKey="fundraisingCCEmails"
            title={texts.FUND_CALL_AND_DISTRIBUTION_EMAILS}
        />
        <DistributorEmailList
            emailsKey="subscriptionProcessCCEmails"
            title={texts.SUBSCRIPTION_PROGRESS_EMAILS}
        />
    </ListContainer>
);

export default Communication;
